import React from "react";

const SocialConnection = () => {
  return (
    <div className="social-connection">
      <div className="social-connection__title">
        <h5 className="heading heading--5">Get in touch with us today!</h5>
      </div>
      <ul className="social-connection__social-list">
        <li className="social-connection__item social-connection__item--fb">
          <a
            href="https://www.facebook.com/leaseplusgroup"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa fa-facebook" aria-hidden="true"></i>
          </a>
        </li>
        <li className="social-connection__item social-connection__item--in">
          <a
            href="https://www.linkedin.com/company/leaseplusgroup"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa fa-linkedin" aria-hidden="true"></i>
          </a>
        </li>
        <li className="social-connection__item social-connection__item--twitter">
          <a
            href="https://twitter.com/leaseplusgroup"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa fa-twitter" aria-hidden="true"></i>
          </a>
        </li>
        <li className="social-connection__item social-connection__item--insta">
          <a
            href="https://www.instagram.com/leaseplusgroup/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa fa-instagram" aria-hidden="true"></i>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default SocialConnection;
